import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import { useAuth } from "../context/AuthContext";

export default function Layout() {
  const [collapsed, setCollapsed] = useState(
    () => localStorage.getItem("sidebar_collapsed") === "1"
  );
  const { user } = useAuth();

  const toggle = () => {
    setCollapsed((c) => {
      localStorage.setItem("sidebar_collapsed", c ? "0" : "1");
      return !c;
    });
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar collapsed={collapsed} />

      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {/* Topbar */}
        <header style={{
          background: "#fff", borderBottom: "1px solid #dfe3e8",
          padding: "0 24px", height: 60, display: "flex",
          alignItems: "center", justifyContent: "space-between",
          position: "sticky", top: 0, zIndex: 10
        }}>
          <button
            onClick={toggle}
            aria-label="Toggle sidebar"
            style={{
              background: "none", border: "1px solid #dfe3e8", borderRadius: 8,
              width: 36, height: 36, display: "flex", alignItems: "center",
              justifyContent: "center", cursor: "pointer", color: "#718096"
            }}
          >
            <Menu size={18} />
          </button>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 13, color: "#718096" }}>{user?.email}</span>
            <span className={user?.role === "superadmin" ? "badge badge-purple" : "badge badge-blue"}>
              {user?.role}
            </span>
          </div>
        </header>

        {/* Page content */}
        <main style={{ flex: 1, padding: 24, maxWidth: 1280, width: "100%", margin: "0 auto" }}>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
